import React from "react";
import "./Disabled.css";

const Disabled = ({ text, type, className }) => {
  return <div className="disabled-button">{text}</div>;
};

export default Disabled;
